import { Button, CircularProgress, Grid, TextareaAutosize, TextField } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";

import { axiosFetch } from "../../../../utils/AxiosFetch";
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ConfirmationModal, CustomizedSnackbar } from "../../../../shared";

function EmployeeQuestion(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false)

    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

    const handleConfirmationModal = () => {
        if (openConfirm) {
            setOpenConfirm(false)
        }
        else {
            setOpenConfirm(true)
        }
    }
    const handleFormSubmit = () => {
        handleDraft(true, 0);
    }
    const handleDraft = (isSubmit, isConfirm) => {
        var question = [];
        var objects;
        var check = false;
        props.question.filter(list => list.questionFor === "Employee").map((list) => {
            var answers = document.getElementById(list.questionId).value
            if (isSubmit === true) {
                console.log(answers)
                if (answers !== "" && answers !== null) {
                    objects = {
                        "questionId": list.questionId,
                        "comments": document.getElementById(list.questionId).value,
                    }
                    question.push(objects)
                    check = true;
                }
                else {
                    check = false;
                }
            }
            else {
                check = true;
                objects = {
                    "questionId": list.questionId,
                    "comments": document.getElementById(list.questionId).value,
                }
                question.push(objects)
            }

        })
        if (question.filter(list => list.comments === "").length === 0) {
            check = false
        }

        if (isSubmit === false) {
            var req = {
                "id": props.formId,
                "isSubmit": isSubmit,
                "Questions": question,
            }
            submitQuestions(req, isSubmit)
        }
        else if ((isSubmit === true && check === true) || question.filter(list => list.comments !== "").length === 6) {
            if (isConfirm === 0) {
                var req = {
                    "id": props.formId,
                    "isSubmit": isSubmit,
                    "Questions": question,
                }
                submitQuestions(req, isSubmit)
            }
            else {
                handleConfirmationModal()
            }
        }
        else if (isSubmit === true && check === false) {
            dispatch(SnackbarActions(true, "warning", "Please fill out all review questions"));

        }
        else {
            alert("alert")
        }



    }
    const submitQuestions = (req, isSubmit) => {
        if (isSubmit === true) {
            setSubmitLoading(true)
        }
        else {
            setLoading(true)
        }
        console.log(req)
        axiosFetch({
            method: "post",
            url: `/Performance/appraisal/questions`,
            requestConfig: req

        })
            .then((res) => {
                if (res.status === 200) {
                    if (isSubmit === true) {
                        setSubmitLoading(false)
                    }
                    else {
                        setLoading(false)
                    }
                    dispatch(SnackbarActions(true, "success", "Your response has been updated successfully"));
                    //props.loadQuestions();
                    navigate('/annual-appraisal');

                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }
    return (
        <div>
            <Grid container>
                {props.question.length > 0 ?
                    props.question.filter(list => list.questionFor === "Employee").map((list) => {
                        return (
                            <Grid item xs={12} className="argus-qa">
                                <p className="questions">{list.questionId}. {list.question} </p>
                                <Box
                                    component="form"
                                    className="answers"
                                    sx={{
                                        '& > :not(style)': { marginBottom: 2 },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <TextareaAutosize
                                        fullWidth
                                        id={list.questionId}
                                        multiline
                                        maxRows={4}
                                        className="argus-answers"
                                        variant="outlined"
                                        defaultValue={list.comments}
                                        disabled={(props.appraisal.statusName !== "Opened") || (parseInt(isUserLogged.userid) !== parseInt(props.appraisal.userId))}
                                    />
                                </Box>
                            </Grid>
                        )
                    })
                    : <></>}

                {props.appraisal.statusName === "Opened" && (parseInt(isUserLogged.userid) === parseInt(props.appraisal.userId)) ?
                    <Grid container xs={12} sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
                        {loading ?
                            <CircularProgress size='2rem' sx={{ marginRight: "10px" }} /> :
                            <Button variant="contained" className="theme-btn cancel-btn" disabled={submitLoading || (props.appraisal.statusName !== "Opened")} sx={{ marginRight: "10px" }} onClick={() => handleDraft(false, 0)}>Save As Draft</Button>}
                        {submitLoading ?
                            <CircularProgress size='2rem' sx={{ marginRight: "10px" }} /> :
                            <Button variant="contained" className="theme-btn" disabled={loading || (props.appraisal.statusName !== "Opened")} onClick={() => handleDraft(true, 1)} >Submit</Button>}
                    </Grid> : ""}
            </Grid>
            <CustomizedSnackbar />
            <ConfirmationModal open={openConfirm} handleClose={handleConfirmationModal} message={"You cannot edit the form after submitting it. Are you sure you want to submit the form?"} handleYes={handleFormSubmit} />


        </div>
    )
}
export default EmployeeQuestion;